import {
  useGetFeatureFlagsQuery
} from 'src/services/billing/billing.service';

import { FeatureType } from 'src/types/subscription.types';

export const useFeatureFlags = () => {

  const { currentData: featureFlags } = useGetFeatureFlagsQuery();

  const featureEnabled = (featureType: FeatureType): boolean => {
    const featureFlag = featureFlags?.find((f) => f.type === featureType);

    if (!featureFlag) {
      return false;
    }

    return featureFlag.available;
  }

  return {
    featureEnabled
  };
};
